import * as React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography
} from '@material-ui/core';
import { useIntl } from 'react-intl';
import { SavedFilterSelection } from 'redux/ducks/settings';

interface SaveSelectionDialogProps {
  name?: string;
  onSave: (name: string) => void;
  onClose: () => void;
  savedSelections: SavedFilterSelection[];
}

const SaveSelectionDialog: React.FunctionComponent<SaveSelectionDialogProps> = (props) => {
  const { onSave, onClose, name: nameProp = '', savedSelections } = props;
  const intl = useIntl();
  const [name, setName] = React.useState<string>(nameProp);

  const handleSave = () => {
    onSave(name);
  };

  const handleNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const {
      target: { value }
    } = event;
    setName(value);
  };

  return (
    <Dialog open onClose={onClose} aria-labelledby='form-dialog-title' maxWidth='sm' fullWidth>
      <DialogTitle id='form-dialog-title'>
        {intl.formatMessage({ id: 'report.filter.saveSelectionAs' })}
      </DialogTitle>
      <DialogContent>
        <TextField
          color='primary'
          InputLabelProps={{ shrink: true }}
          autoFocus
          margin='dense'
          label={intl.formatMessage({ id: 'name' })}
          value={name}
          onChange={handleNameChange}
          fullWidth
          helperText={
            savedSelections.some((selection) => selection.name === name) ? (
              <Typography color='error' variant='caption'>
                {intl.formatMessage({ id: 'report.filter.savedSelectionExists' })}
              </Typography>
            ) : undefined
          }
        />
      </DialogContent>
      <DialogActions>
        <Button variant='text' onClick={onClose} color='primary'>
          {intl.formatMessage({ id: 'base.cancel' })}
        </Button>
        <Button
          disabled={name.length === 0}
          variant='contained'
          onClick={handleSave}
          color='primary'
        >
          {intl.formatMessage({ id: 'base.save' })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveSelectionDialog;
